import React from 'react';
import { Colors, Icon, ProgressBar, useMediaQueryContext } from '@fourthwall/components';
import { ArrowLongLeftIcon, ArrowLongRightIcon, BurgerIcon, CloseIcon } from '@fourthwall/icons';
import * as S from './styled';
import { RoundedButton } from '../../../RoundedButton';
export const ContentHeader = ({ title, progressValue, maxProgressValue, onOpenDrawer, onPrevious, onNext, onClose, }) => {
    const media = useMediaQueryContext();
    const renderContent = () => {
        if (!media.tablet) {
            return (React.createElement(React.Fragment, null,
                React.createElement(RoundedButton, { size: "small", onClick: onOpenDrawer },
                    React.createElement(Icon, { component: BurgerIcon, height: 12 })),
                React.createElement(S.Title, null, title),
                progressValue < maxProgressValue && (React.createElement(RoundedButton, { size: "small", onClick: onNext },
                    React.createElement(Icon, { component: ArrowLongRightIcon, height: 12 })))));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(S.Title, null, title),
            React.createElement(S.Actions, null,
                progressValue > 1 && (React.createElement(RoundedButton, { onClick: onPrevious },
                    React.createElement(Icon, { component: ArrowLongLeftIcon, height: 12 }))),
                progressValue < maxProgressValue && (React.createElement(RoundedButton, { onClick: onNext },
                    "Next",
                    React.createElement(Icon, { component: ArrowLongRightIcon, height: 12 }))),
                progressValue === maxProgressValue && (React.createElement(RoundedButton, { onClick: onClose },
                    "Close",
                    React.createElement(Icon, { component: CloseIcon, height: 12 }))))));
    };
    return (React.createElement(S.Container, null,
        React.createElement(ProgressBar, { value: progressValue, max: maxProgressValue, height: media.tablet ? 6 : 4, barColor: Colors.G300 }),
        React.createElement(S.Content, null, renderContent())));
};
